import {
    RESET_CREATE_PLAN_BIOPSY_SHARD,
    SET_ACTIVE_CORE,
    SET_CORE_LOCATIONS,
    SET_PATH_REPORT_URL,
    SET_PATH_SUMMARY_URL,
    SET_TEMPLATE_URL,
    SET_BIOPSY_ERROR,
    SET_IS_CORE_FOCUSED,
    SET_IS_ON_MESH_VIEWER_CONTROL,
} from "./actions";
import { initialState } from "./init";

export default CreatePlanBiopsyReducer;

function CreatePlanBiopsyReducer(state = initialState, action = {}) {
    switch (action.type) {
        case SET_PATH_REPORT_URL:
            return setPathReportURL(state, action);
        case SET_PATH_SUMMARY_URL:
            return setPathSummaryURL(state, action);
        case SET_TEMPLATE_URL:
            return setTemplateURL(state, action);
        case SET_CORE_LOCATIONS:
            return setCoreLocations(state, action);
        case SET_ACTIVE_CORE:
            return setActiveCore(state, action);
        case RESET_CREATE_PLAN_BIOPSY_SHARD:
            return resetCreatePlanBiopsyShard(state, action);
        case SET_BIOPSY_ERROR:
            return setBiopsyError(state, action);
        case SET_IS_CORE_FOCUSED:
            return setIsCoreFocused(state, action);
        case SET_IS_ON_MESH_VIEWER_CONTROL:
            return setIsOnMeshViewerControl(state, action);
        default:
            return state;
    }
}
function setPathReportURL(state, action) {
    return {
        ...state,
        pathReportURL: action.url,
    };
}

function setPathSummaryURL(state, action) {
    return {
        ...state,
        pathSummaryURL: action.url,
    };
}

function setTemplateURL(state, action) {
    return {
        ...state,
        templateURL: action.url,
    };
}

function setCoreLocations(state, action) {
    let stateCpy = JSON.parse(JSON.stringify(state));
    stateCpy.coreLocations = action.cores;
    return stateCpy;
}

function setActiveCore(state, action) {
    let stateCpy = JSON.parse(JSON.stringify(state));
    stateCpy.activeCore = action.core;
    return stateCpy;
}

function resetCreatePlanBiopsyShard() {
    return initialState;
}

function setBiopsyError(state, action) {
    let stateCpy = JSON.parse(JSON.stringify(state));
    stateCpy.bxError = action.bxError;
    return stateCpy;
}

function setIsCoreFocused(state, action) {
    let stateCpy = JSON.parse(JSON.stringify(state));
    stateCpy.isCoreFocused = action.isCoreFocused;
    return stateCpy;
}

function setIsOnMeshViewerControl(state, action) {
    let stateCpy = JSON.parse(JSON.stringify(state));
    stateCpy.isOnMeshViewerControl = action.isOnMeshViewerControl;
    return stateCpy;
}
